import {
  convertUTCDateTimeToLocal,
  toDisplayDateTime,
} from "../../blocks/fields/formatDate";

/** The derived send date the page bar shows under the recipient. */
export const CommunicationActivitySendDateField = "communicationactivitysenddate";

// The subject is the communication's name, so the page is named by who it went to and when.
export function adaptCommunicationActivityRecord(
  record: Record<string, unknown>
): Record<string, unknown> {
  const sendDate = toDisplayDateTime(
    convertUTCDateTimeToLocal(
      record.scheduledstart as string | Date | null | undefined
    )?.toDate()
  );

  return {
    ...record,
    [CommunicationActivitySendDateField]: sendDate || undefined,
  };
}
